export const IMAGES = {
  EMPTY_SEARCH: `${process.env.REACT_APP_CLOUD_FRONT}/media/images/il_no_results.svg`,
  ADDRESS_ON_MAP_ICON: `${process.env.REACT_APP_CLOUD_FRONT}/media/images/ic_map_adress.svg`,
};
